import { Button, Flex, Form, Input, Typography } from 'antd'
import { useTheme } from 'antd-style'
import { useNavigate } from 'react-router-dom'

import { useAccountServiceRequestResetPasswordEndpoint } from 'src/api/queries'
import { requiredRules, RESET_EMAIL } from 'src/app-constants'
import { message, Text } from 'src/components'
import { useLocalStorage } from 'src/hooks'
import { useLocales } from 'src/locales'
import { paths } from 'src/paths'

import { AuthHeader } from '../components'
import { useStyles } from '../styles'

const { Link } = Typography

export const ForgotPassword = () => {
  const { t } = useLocales()
  const { styles } = useStyles()
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const palette = useTheme()

  const { setValue } = useLocalStorage(RESET_EMAIL, '')

  const { mutate, isPending } = useAccountServiceRequestResetPasswordEndpoint({
    onSuccess: () => {
      navigate(paths.auth.resetConfirm)
      setValue(form.getFieldValue('email'))
      message.success(t('auth.reset_password_request_success'))
    },
    onError: () => {
      message.error(t('auth.login_error'))
    }
  })

  const onSubmit = async () => {
    const values = await form.validateFields()

    const requestBody = {
      email: values?.email,
      password: values?.password
    }

    mutate({ requestBody })
  }

  const onRedirect = () => {
    navigate(paths.auth.root)
  }

  return (
    <Flex vertical gap={32}>
      <AuthHeader
        title={t('auth.forgot_password_title')}
        description={t('auth.forgot_password_subtitle')}
      />

      <Form layout="vertical" form={form}>
        <Flex vertical gap={16}>
          <Form.Item
            name="email"
            label={t('form.email')}
            rules={requiredRules?.concat({
              type: 'email',
              message: t('form.email_error')
            })}
            className={styles.formItem}
          >
            <Input size="large" placeholder={t('form.email_placeholder')} />
          </Form.Item>

          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            loading={isPending}
          >
            {t('auth.send_instructions')}
          </Button>

          <Flex gap={8} align="center" justify="center">
            <Text color={palette.black.black1}>
              {t('auth.remember_password')}
            </Text>

            <Link onClick={onRedirect}>
              <Text color={palette.orange} weight={600}>
                {t('auth.return_to_auth')}
              </Text>
            </Link>
          </Flex>
        </Flex>
      </Form>
    </Flex>
  )
}
